import React from "react";
import CommonButtons from "../../../../../../shared/components/CommonButtons";
import CommonTable from "../../../../../grocery/components/CommonTable";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { CustomerData } from "src/shared/services/interfacev2";

interface Props {
  customers: CustomerData[];
  total: { totalRecords: string; totalPage: string };
  pageNumber: number;
  setPageNumber: (p: number) => void;
  onSelect: (id: string, customer: CustomerData) => void;
  loading?: boolean;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const CustomerTable: React.FC<Props> = ({ customers, total, pageNumber, setPageNumber, onSelect, loading = false }) => {
  const validCustomers = customers.filter((c) => c && c._id && c._id.$oid && c.firstName && c.phones && c.phones[0] && c.phones[0].phone);

  const tableData = validCustomers.map((c) => ({ id: c._id.$oid, Name: `${c.firstName} ${c.middleName} ${c.lastName}`, phone_number: c.phones[0].phone }));

  const headCells: { id: keyof (typeof tableData)[0]; label: string }[] = [
    { id: "Name", label: "Name" },
    { id: "phone_number", label: "Phone Number" },
  ];

  return (
    <div className="flex flex-col w-full h-full">
      {loading ? (
        <p className="text-center py-2">Loading...</p>
      ) : (
        <div className="thin-scrollbar flex-1 overflow-auto">
          <CommonTable
            className="w-full min-w-[515px] max-w-[900px] h-[350px]"
            data={tableData}
            showToolbar={false}
            headCells={headCells}
            title="Customers"
            selectable={false}
            pagenation={false}
            denseToggle={true}
            denseDefault={false}
            pageSize={10}
            onRowClick={(id) => {
              const selectedCustomer = validCustomers.find((c) => c._id.$oid === id.toString());
              if (selectedCustomer) onSelect(selectedCustomer._id.$oid, selectedCustomer);
            }}
          />
        </div>
      )}

      <div className="w-full flex flex-col sm:flex-row justify-between items-center py-2 gap-2">
        <CommonButtons label="Previous" icon={ChevronLeft} iconPosition={"left"} disabled={pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)} />
        <div className="flex items-center gap-3">
          <p className="bg-gray-100 px-3 py-1 rounded-md text-sm font-medium shadow-sm">
            Page <span className="font-semibold">{pageNumber}</span> of <span className="font-semibold">{total.totalPage}</span>
          </p>
          <p className="bg-gray-100 px-3 py-1 rounded-md text-sm font-medium shadow-sm">
            Total Records: <span className="font-semibold">{total.totalRecords}</span>
          </p>
        </div>
        <CommonButtons
          label="Next"
          iconPosition="right"
          icon={ChevronRight}
          disabled={validCustomers.length === 0 || Number(total.totalPage) === pageNumber}
          onClick={() => setPageNumber(pageNumber + 1)}
        />{" "}
      </div>
    </div>
  );
};

export default CustomerTable;
